import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { groupFormAction } from "../../redux/rootReducer";
import { GROUP_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateGroupSagaAction } from "../../redux/sagaActions";

const GroupForm = () => {
    const dispatch = useDispatch();

    const establishmentList = useSelector(state => state.establishmentList);
    const groupForm = useSelector(state => state.groupForm);

    if (!groupForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                           onClick={ () => dispatch(groupFormAction(GROUP_FORM_INITIAL)) }
                        />
                        <div className="form__title">{
                            groupForm.id
                                ? `Настройки группы № ${ groupForm.id }`
                                : 'Новая группа'
                        }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название группы</div>
                        <input type="text" className="input"
                               value={ groupForm.name }
                               onInput={ event => dispatch(groupFormAction({
                                   ...groupForm,
                                   name: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...groupForm.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(groupFormAction({
                                                ...groupForm,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ groupForm.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => dispatch(updateGroupSagaAction({
                                 id: groupForm.id,
                                 name: groupForm.name,
                                 establishments: JSON.stringify(groupForm.establishments)
                             })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupForm;